import { useCallback, useState, useEffect } from 'react'

export interface DialogType {
  /**
   * If `true`, display the dialog, else hide the dialog.
   * @default: false
   */
  visible: boolean
  /**
   * Function to set visible = true.
   */
  open: () => void
  /**
   * Function to set visible = false.
   */
  close: () => void
}

function useDialog(initialValue = false): DialogType {
  const [visible, setVisible] = useState(initialValue)

  useEffect(() => {
    setVisible(initialValue)
  }, [initialValue])

  const open = useCallback(() => {
    setVisible(true)
  }, [setVisible])

  const close = useCallback(() => {
    setVisible(false)
  }, [setVisible])

  return {
    visible,
    open,
    close
  }
}

export default useDialog
